import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const SupplierCard = ({ supplier, language }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/suppliers/${supplier?.id}`);
  };

  return (
    <div
      onClick={handleCardClick}
      className="bg-card border border-border rounded-lg overflow-hidden hover:shadow-lg transition-smooth cursor-pointer group"
    >
      <div className="relative h-48 bg-muted overflow-hidden">
        <Image
          src={supplier?.logo}
          alt={supplier?.logoAlt}
          className="w-full h-full object-contain p-6 group-hover:scale-105 transition-smooth"
        />
        {supplier?.verified && (
          <div className="absolute top-3 right-3 bg-success text-success-foreground px-3 py-1 rounded-full text-xs font-medium flex items-center gap-1">
            <Icon name="BadgeCheck" size={14} />
            {language === 'en' ? 'Verified' : '已验证'}
          </div>
        )}
      </div>
      <div className="p-5">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-2 group-hover:text-primary transition-smooth">
          {language === 'en' ? supplier?.name_en : supplier?.name_zh}
        </h3>

        <div className="flex items-center gap-2 text-sm text-muted-foreground mb-3">
          <Icon name="MapPin" size={16} />
          <span>{language === 'en' ? supplier?.country_en : supplier?.country_zh}</span>
        </div>

        <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
          {language === 'en' ? supplier?.description_en : supplier?.description_zh}
        </p>

        <div className="grid grid-cols-3 gap-3 mb-4">
          <div className="text-center">
            <div className="text-xl font-semibold text-primary">{supplier?.yearsInBusiness}</div>
            <div className="text-xs text-muted-foreground">{language === 'en' ? 'Years' : '年'}</div>
          </div>
          <div className="text-center">
            <div className="text-xl font-semibold text-primary">{supplier?.varietiesOffered}</div>
            <div className="text-xs text-muted-foreground">{language === 'en' ? 'Varieties' : '品种'}</div>
          </div>
          <div className="text-center">
            <div className="text-xl font-semibold text-primary">{supplier?.certifications?.length}</div>
            <div className="text-xs text-muted-foreground">{language === 'en' ? 'Certs' : '证书'}</div>
          </div>
        </div>

        {supplier?.certifications?.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {supplier?.certifications?.slice(0, 3)?.map((cert, index) => (
              <span
                key={index}
                className="px-2 py-1 bg-accent/10 text-accent-foreground text-xs rounded-md font-medium"
              >
                {cert}
              </span>
            ))}
            {supplier?.certifications?.length > 3 && (
              <span className="px-2 py-1 bg-muted text-muted-foreground text-xs rounded-md font-medium">
                +{supplier?.certifications?.length - 3}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SupplierCard;